import { BaseMutations } from '@/store/base-mutations';
import { Organizations } from '@/modules/organizations/types';
import OrganizationCheckState from './state';

export default class OrganizationCheckMutations extends BaseMutations<OrganizationCheckState> {
  SET_ORGANIZATIONS(search_orgs: Organizations.OrganizationCheck[]) {
    this.state.search_orgs = search_orgs;
  }

  TOGGLE_LOADING_ORGANIZATIONS(toggle: boolean) {
    this.state.search_orgs_loading = toggle;
  }
}
